import axios from 'axios';
import { APIError } from '@models/index';
import { DEFAULT_ERROR_MESSAGE, SESSION_ERROR_MESSAGE } from 'config/api';

export const loadConfig = async () => {
  const cleanUrl = (url: string): string => {
    const trimmedUrl = url.replace(/\s+/g, '');
    return trimmedUrl.endsWith('/') ? trimmedUrl.slice(0, -1) : trimmedUrl;
  };

  if (
    typeof window !== 'undefined' &&
    window.navigator.userAgent.toLowerCase().includes('electron')
  ) {
    const BASE_URL = await window.config.electronAPI();
    return cleanUrl(BASE_URL);
  }
  try {
    const res = await axios('config.json')
      .then((res) => {
        console.log(res);
        return res;
      })
      .catch((err) => {
        console.log(err);
        return err;
      });
    if (res.status === 200 || res.status === 201) {
      return cleanUrl(res.data.API_BASE_URL);
    }
    console.log('Axios Error', res.status);
    return null;
  } catch {
    const config = await import('assets/config.json');
    return cleanUrl(config.API_BASE_URL);
  }
};

export const isAuthError = (error: APIError) => error.response?.status === 401;

export const getErrorMessage = (error: APIError, message?: string) => {
  if (isAuthError(error)) {
    window.location.href = '/';
    return SESSION_ERROR_MESSAGE;
  }
  return message ?? error.response?.data.message ?? DEFAULT_ERROR_MESSAGE;
};
